"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOUBLE_ELIMINATION_POSITIONS = exports.SINGLE_ELIMINATION_POSITIONS = void 0;
/**
 * Do not change the ordering of this array. This will break the final tournament prize distribution.
 */
exports.SINGLE_ELIMINATION_POSITIONS = [1, 2, 3, 5, 9, 17, 33, 65, 129, 257, 513, 1025];
/**
 * Do not change the ordering of this array. This will break the final tournament prize distribution.
 */
exports.DOUBLE_ELIMINATION_POSITIONS = [
    1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025,
];
//# sourceMappingURL=last-winning-positions.js.map